import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=46675383&scoped=true&lang=pug&"
import script from "./GamesList.vue?vue&type=script&lang=js&"
export * from "./GamesList.vue?vue&type=script&lang=js&"
import style0 from "./GamesList.vue?vue&type=style&index=0&id=46675383&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46675383",
  null
  
)

export default component.exports